import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-text" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "error-text__icon k-icon k-i-exception" }, null, -1)
const _hoisted_3 = { class: "error-text__message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('error_module.error_message', { errorMessage: _ctx.errorMessage })), 1)
  ]))
}